import { Button, ButtonGroup, Card, Heading, Modal, Page, Stack, TextContainer, TextStyle } from "@shopify/polaris";
import './messaging-tools.scss' ;
import qrCode from "../../../assets/images/qrCode.png" ;
import { clevertapEventPush, CT_EVENT_IDS } from "../../../utils/clevertapUtils";
import { useState } from "react";
import { MESSAGING_TOOLS } from "../../../constants/constants";

const MessagingTools = (props : any) => {

  const [openTutorial, setopenTutorial] = useState(false);
  const openChromeExtension = () => {
    let url = MESSAGING_TOOLS.link;
    window.open(url, '_blank');
  };

    const populateTopRow = () => {
        return (<TextContainer>
            <Heading>
                {MESSAGING_TOOLS.title}
            </Heading>
            <br />
            <TextStyle variation="subdued">
                {MESSAGING_TOOLS.description}
            </TextStyle>
        </TextContainer> );
    };

    const populateDesktopColumn = () => {
        return (    
        <Stack vertical>
            <TextContainer>
                <TextStyle variation="strong">
                    {MESSAGING_TOOLS.desktop.title}
                </TextStyle>
                <br /> <br />
                <TextStyle variation="subdued">
                    {MESSAGING_TOOLS.desktop.description}
                </TextStyle>
            </TextContainer>
            <div>
                <br />
                <ButtonGroup>
                <Button primary onClick={openChromeExtension}>
                    {MESSAGING_TOOLS.desktop.install_button}
                </Button>
                {!props.NoTutorial && <div className="greenButton">
                    <Button monochrome outline 
                    onClick={() => setopenTutorial(true)}>
                        {MESSAGING_TOOLS.desktop.tutorial_button}
                    </Button>
                </div>}
                </ButtonGroup>
            </div>
        </Stack>);
    };

    const populateMobileColumn = () => {
        return (    
            <Stack vertical>
                <TextContainer>
                    <TextStyle variation="strong">
                        {MESSAGING_TOOLS.mobile.title}
                    </TextStyle>
                    <br /> <br />
                    <TextStyle variation="subdued">
                        {MESSAGING_TOOLS.mobile.description}
                    </TextStyle>
                </TextContainer>
                <div className="qr-container">
                 <div className="qr-code">
                    <img src={qrCode} width="100px" height="100px"></img>
                 </div>
                 <div className="qr-description">
                    <b>
                    <TextStyle variation="subdued">
                        {MESSAGING_TOOLS.mobile.qr_code_1}
                    <br />
                        {MESSAGING_TOOLS.mobile.qr_code_2}
                    </TextStyle>
                    </b>
                 </div>
                </div>
            </Stack>);
    };

    return (
        <Page>
        <Modal
            open={openTutorial}
            sectioned={true}
            title={'Tutorial video'}
            onClose={() => {
            setopenTutorial(false);
            document.body.classList.remove('tutorial-modal');
            clevertapEventPush({
                eventId: CT_EVENT_IDS.TUTORIAL_VIDEO_CLOSED,
                eventData: {},
            });
            }}
        >
            <iframe
            id='ytplayer'
            width='100%'
            height='360'
            allow='fullscreen'
            src={'https://www.youtube.com/embed/8ug_qyXxqAs'}
            frameBorder='0'
            title={'Extension Tutorial Video'}
            ></iframe>
        </Modal>
        <Stack vertical>
            <div>
                {populateTopRow()}
                <br />
            </div>
            <div>
                <div className="msg-container">
                    <div className="msg-column">
                        {populateDesktopColumn()}
                    </div>
                    <div className="msg-column">
                        {populateMobileColumn()}
                    </div>
                </div>
            </div>
        </Stack>
        </Page>
    );
};

export default MessagingTools ;